// extracted by mini-css-extract-plugin
export default {"game":"LotterySelector_game__0owpc","wrap":"LotterySelector_wrap__Unr0q","buttonWrap":"LotterySelector_buttonWrap__DMQs1","header":"LotterySelector_header__zel47"};